/**
 * Configuration class for the application
 * Centralizes access to environment variables with type safety
 */
export class Config {
  /**
   * Base URL for API requests
   */
  static get apiBaseUrl(): string {
    return import.meta.env.VITE_API_BASE_URL as string
  }

  /**
   * Base URL for the application
   */
  static get appBaseUrl(): string {
    return import.meta.env.VITE_APP_BASE_URL as string
  }

  /**
   * Stripe billing portal URL
   */
  static get stripeBillingUrl(): string {
    return import.meta.env.VITE_STRIPE_BILLING_URL as string
  }

  /**
   * Sentry DSN for error tracking
   */
  static get sentryDsn(): string {
    return import.meta.env.VITE_SENTRY_DSN as string
  }

  /**
   * Generate Stripe billing URL with prefilled email
   */
  static getStripeBillingUrl(email: string): string {
    return `${this.stripeBillingUrl}?prefilled_email=${email}`
  }

  /**
   * Get the public booking page URL for a given booking URL slug
   */
  static getBookingPageUrl(bookingUrl: string): string {
    return `${this.apiBaseUrl}/book/${bookingUrl}`
  }
}
